import { render, staticRenderFns } from "./PatientPersonalDataCard.vue?vue&type=template&id=64c0a4e6&scoped=true&"
import script from "./PatientPersonalDataCard.vue?vue&type=script&lang=js&"
export * from "./PatientPersonalDataCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c0a4e6",
  null
  
)

export default component.exports